module.exports = __webpack_public_path__ + "img/eMobile.cd86beff.png";